import { render, staticRenderFns } from "./SchoolWidget.vue?vue&type=template&id=80e68c0a&scoped=true"
import script from "./SchoolWidget.vue?vue&type=script&lang=js"
export * from "./SchoolWidget.vue?vue&type=script&lang=js"
import style0 from "./SchoolWidget.vue?vue&type=style&index=0&id=80e68c0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e68c0a",
  null
  
)

export default component.exports